export default __webpack_public_path__ + "static/Chevron_TCC22_Website_300x600-e80e37065522634eb214f1b15c942c65.jpg";